import { NavLink } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="nav-container">

        {/* LOGO */}
        <div className="nav-logo">
          <img
            src="/images/rajbharti-logo.png"
            alt="Rajbharti Quartzite Industries"
            className="nav-logo-img"
          />
          <div className="nav-brand-text">
            <span className="brand-main">Gulmohar Pulses</span>
            {/* <span className="brand-sub">Rajbharti Quartzite Industries</span> */}
          </div>
        </div>

        {/* LINKS */}
        <div className={`nav-links ${open ? "open" : ""}`}>
          <NavLink to="/" end onClick={() => setOpen(false)}>Home</NavLink>
          <NavLink to="/about" onClick={() => setOpen(false)}>About Us</NavLink>
          <NavLink to="/contact-us" onClick={() => setOpen(false)}>Contact Us</NavLink>
        </div>
        <button className="nav-toggle" onClick={() => setOpen(!open)}>
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>

      </div>
    </nav>
  );
}
